import { render, staticRenderFns } from "./ServiceTypeAttachmentDepartmentsManagement.vue?vue&type=template&id=16cf90f0&scoped=true"
import script from "./ServiceTypeAttachmentDepartmentsManagement.vue?vue&type=script&lang=js"
export * from "./ServiceTypeAttachmentDepartmentsManagement.vue?vue&type=script&lang=js"
import style0 from "./ServiceTypeAttachmentDepartmentsManagement.vue?vue&type=style&index=0&id=16cf90f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cf90f0",
  null
  
)

export default component.exports